import {
  CORPORATE_CUSTOMER_SUPPORT_EMAIL,
  DASHBOARD_URL,
  FLOW_TYPE,
  HELP_CENTER,
  HISTORY_URL,
  INSTAPOINTS_URL,
  PAYEE_LIST_URL,
  REFERRAL_URL,
  TRANSFER_MONEY_URL,
  BASE_CDN_CONSUMER_URL
} from '@Utils/constants';

import { NavItem } from '../SideNav.types';

import { EVENT_ROUTE_KEYS } from '@Utils/events/eventsConstants';
import { INSTAPOINTS_COIN_ICON } from '@Images';

export const sideNavMenuItems: NavItem[] = [
  {
    key: 'home',
    label: 'Home',
    icon: `${BASE_CDN_CONSUMER_URL}home-dark.svg`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}home-pink.svg`,
    route: DASHBOARD_URL,
    routeKey: EVENT_ROUTE_KEYS.Dashboard,
    flowType: FLOW_TYPE.DASHBOARD
  },
  {
    key: 'send-money',
    label: 'Send money',
    icon: `${BASE_CDN_CONSUMER_URL}send-dark.svg`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}send-pink.svg`,
    route: TRANSFER_MONEY_URL,
    routeKey: EVENT_ROUTE_KEYS.SendMoney,
    flowType: FLOW_TYPE.TRANSACTION
  },
  {
    key: 'transactions',
    label: 'Transactions',
    icon: `${BASE_CDN_CONSUMER_URL}activity-dark.svg`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}activity-pink.svg`,
    route: HISTORY_URL,
    routeKey: EVENT_ROUTE_KEYS.TransactionHistory,
    flowType: FLOW_TYPE.TRANSACTION_HISTORY
  },
  {
    key: 'recipients',
    label: 'Recipients',
    icon: `${BASE_CDN_CONSUMER_URL}recipients-dark.svg`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}recipients-pink.svg`,
    route: PAYEE_LIST_URL,
    routeKey: EVENT_ROUTE_KEYS.AddBeneficiary,
    flowType: FLOW_TYPE.BENEFICIARY
  },
  {
    key: 'instapoints',
    label: 'Instapoints',
    icon: `${INSTAPOINTS_COIN_ICON}`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}balance-pink.svg`,
    route: INSTAPOINTS_URL,
    flowType: FLOW_TYPE.INSTAPOINT,
    routeKey: EVENT_ROUTE_KEYS.Instapoints
  },
  {
    key: 'rewards',
    label: 'Rewards',
    icon: `${INSTAPOINTS_COIN_ICON}`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}balance-pink.svg`,
    route: INSTAPOINTS_URL,
    routeKey: EVENT_ROUTE_KEYS.Rewards,
    flowType: FLOW_TYPE.REWARDS
  },
  {
    key: 'refer-earn',
    label: 'Refer & earn',
    icon: `${BASE_CDN_CONSUMER_URL}refer-earn-dark.svg`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}refer-earn-pink.svg`,
    route: REFERRAL_URL,
    routeKey: EVENT_ROUTE_KEYS.ReferAndEarn,
    flowType: FLOW_TYPE.REFER_EARN
  },
  {
    key: 'help-centre',
    label: 'Help centre',
    icon: `${BASE_CDN_CONSUMER_URL}tooltip-dark.svg`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}tooltip-pink.svg`,
    route: HELP_CENTER,
    routeKey: EVENT_ROUTE_KEYS.HelpCenter,
    flowType: FLOW_TYPE.HELP_CENTER
  },
  {
    key: 'help-centre-corporate',
    label: 'Help',
    icon: `${BASE_CDN_CONSUMER_URL}tooltip-dark.svg`,
    activeIcon: `${BASE_CDN_CONSUMER_URL}tooltip-pink.svg`,
    route: `mailto:${CORPORATE_CUSTOMER_SUPPORT_EMAIL}`,
    routeKey: EVENT_ROUTE_KEYS.HelpCenter,
    flowType: FLOW_TYPE.HELP_CENTER
  }
];
